module.exports = __webpack_public_path__ + "img/2-01-07-sleep-wht.9d388b88.svg";